import { ActionMenuLabels } from '../i18n/action-menu-labels';
import { Action } from 'rxjs/internal/scheduler/Action';
export class NxpActionMenuConfig {

    public static ID_DIVIDER = 'divider';
    public static ID_HOLDINGS = 'holdings';
    public static ID_ACTIVITY = 'activity';
    public static ID_BALANCES = 'balances';
    public static ID_PCF = 'pcf';
    public static ID_HOLDINGS_BY_SYMBOL = 'holdings-by-symbol';
    public static ID_HOLDINGS_IP_TOTALS = 'holdings-iptotal';
    public static ID_QUOTES = 'quotes';
    public static ID_DIGEST = 'digest';
    public static ID_OPTION_QUOTE = 'option-quote';
    public static ID_SECURITY_NEWS = 'security-news';
    public static ID_TRADE_BUY_MORE_EQUITY = 'trade-buy-more-equity';
    public static ID_HOLDINGS_BUY_MORE_EQUITY = 'holdings-buy-more-equity';
    public static ID_TRADE_SELL_EQUITY = 'trade-sell-equity';
    public static ID_TRADE_SELL_POSITIONS = 'trade-sell-positions';
    public static ID_TRADE_SELL_COVERED = 'trade-sell-covered';
    public static ID_TRADE_SELL_ALL_EQUITY = 'trade-sell-all-equity';
    public static ID_TRADE_SELL_SHORT = 'trade-sell-short';
    public static ID_TRADE_BUY_TO_COVER = 'trade-buy-to-cover';
    public static ID_TRADE_BUY_MF = 'trade-buy-mf';
    public static ID_TRADE_BUY_529 = 'trade-buy-mf-529plan';
    public static ID_TRADE_REDEEM = 'trade-redeem';
    public static ID_TRADE_REDEEM_529 = 'trade-redeem-mf-529plan';
    public static ID_TRADE_EXCHANGE = 'trade-exchange';
    public static ID_TRADE_EXCHANGE_529 = 'trade-exchange-mf-529plan';
    public static ID_TRADE_BUY_CALLS_TO_OPEN = 'trade-buy-calls-to-open';
    public static ID_TRADE_SELL_CALLS_TO_OPEN = 'trade-sell-calls-to-open';
    public static ID_TRADE_BUY_PUTS_TO_OPEN = 'trade-buy-puts-to-open';
    public static ID_TRADE_SELL_PUTS_TO_OPEN = 'trade-sell-puts-to-open';
    public static ID_TRADE_CLOSE_CALLS_PUTS = 'trade-close-calls-puts';
    public static ID_TRADE_AWAY_FI = 'trade-away-fi';
    public static ID_TRADE_SELL_FI = 'trade-sell-fi';
    public static ID_CFRA_QUICKVIEW = 'cfra-quickview';
    public static ID_ACCOUNT_NOTE = 'account-note';
    public static ID_CALCULATE_LOI_ROA = 'calculate-loiroa';
    public static ID_SELL_POSITIONS = 'sell-positions';
    public static ID_PERIODIC_INSTRUCTIONS = 'periodic-instructions';
    public static ID_DIVIDEND_REINVEST = 'dividend-reinvestment';
    public static ID_CALCULATE_CDSC = 'calculate-cdsc';
    public static ID_TRADE_SELL_COVERED_OPTIONS = 'trade-sell-covered-options';

    /* Default navigation target for the context types */
    public static DEFAULT_NAVTARGET_CONTEXT: any = {
        account: 'my-practice/details/holdings/positions',
        household: 'my-practice/details/holdings/positions',
        group: 'my-practice/details/holdings/positions',
        client: 'my-practice/details/holdings/positions',
        clntaccnt_search: 'my-practice/details/holdings/positions'
    };

    /* Below is to handle the domain value sent in the search response until we standardize the contexts */
    public static DEFAULT_NAVTARGET_ACTIONS: any = {
        balances: 'my-practice/details/balances/balance-summary',
        holdings: 'my-practice/details/holdings/positions',
        activity: 'my-practice/details/activity',
        pcf: 'my-practice/details/pcf/incoming-cash'
    };

    public static NXP_ACTION_MENU_DUPLICATE_MAPPING: Map<string, string> = new Map([
        ['account-OPEN', 'account'],
        ['security-commonstocks', 'security-equity'],
        ['security-moneymkt', 'security-mutfund'],
        ['security-municipalbonds', 'security-fixedincome'],
        ['security-munidebt', 'security-fixedincome'],
        ['security-uit', 'security-fixedincome'],
        ['security-govtsec', 'security-fixedincome']
        ]);

    /*
    NXP_ACTION_MENU_MASTER object defines the menu items for the context menu.

    Structure is as follows.

        <menuobject_name>: {
            menuId: 'xyx', // Used internally
            menuLabel: 'xyz', // Displayed to the user
            gotoPage: 'nav_target', // Default navigation target
            callbackEvent: 'eventName', // Name of the event to be used to communicate back to the component
            role: 'entitlements', // Requied entitlements. Need to be configured in portal services.
            payloadMetadata: {}, // An object that provides the list of parameters that need to be passed to target
            disabled: true/false, // True if the menu should not be displayed. By default, false.
            icon: 'icon_class' // Add an icon name if needed. For future use.
        }

        payloadMetadata has a member named params which supplies the list of parameters to pass to target application.

        Sample:
        payloadMetadata: {
            params: 'symId,acctType,transactionType=BUY,PrepopTrdtype=Buy,qty={quantity}'
        }

        Each attribute in the params list will be used to get the value from the payload.params object passed by the component.

        For cases where the parameter name that needs to be passed to target application and the attribute coming from the component
        are different, we indicate the value with {}.

        Eg: qty={quantity} - qty is the parameter that target expects whereas the component model has it as quantity.

        For these cases, take the attribute name within the paranthesis and find and use the value for the attribute from incoming payload.

        An event with the value supplied in 'callbackEvent' will be triggered when the menu is clicked,
        if this attribute is passed by the component.

    */
    public static NXP_ACTION_MENU_MASTER = {
        divider: {
            menuId: 'divider',
            menuLabel: '',
            gotoPage: '',
            isDivider: true
        },
        holdings: {
            menuId: 'holdings',
            menuLabel: ActionMenuLabels.HOLDINGS,
            gotoPage: 'my-practice/details/holdings/positions'
        },
        activity: {
            menuId: 'activity',
            menuLabel: ActionMenuLabels.ACTIVITY,
            gotoPage: 'my-practice/details/activity'
        },
        balances: {
            menuId: 'balances',
            menuLabel: ActionMenuLabels.BALANCES,
            gotoPage: 'my-practice/details/balances/balance-summary'
        },
        pcf: {
            menuId: 'pcf',
            menuLabel: ActionMenuLabels.PROJ_CASH_FLOW,
            gotoPage: 'my-practice/details/pcf/incoming-cash'
        },
        'holdings-by-symbol': {
            menuId: 'holdings-by-symbol',
            menuLabel: ActionMenuLabels.HOLDINGS_BY_SYMBOL,
            gotoPage: 'holdings-bysymbol-ibdoffip',
            payloadMetadata: {
                params: 'securityType, securityValue, domaintype=ibdoffip, publisherId=main-menu'
            },
            domain: 'ibdoffip'
        },
        'holdings-iptotal': {
            menuId: 'holdings-iptotal',
            menuLabel: ActionMenuLabels.IP_TOTALS,
            gotoPage: 'holdings-iptotals-ibdoffip',
            payloadMetadata: {
                params: 'securityType, securityValue, domaintype=ibdoffip, publisherId=main-menu'
            },
            domain: 'ibdoffip'
        },
        quotes: {
            menuId: 'quotes',
            menuLabel: ActionMenuLabels.QUOTES,
            gotoPage: 'security-digest',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip'
            },
            domain: 'security'
        },
        digest: {
            menuId: 'digest',
            menuLabel: ActionMenuLabels.DIGEST,
            gotoPage: 'security-digest',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip'
            },
            domain: 'security'
        },
        'option-quote': {
            menuId: 'option-quote',
            menuLabel: ActionMenuLabels.OPTION_QUOTE,
            gotoPage: 'security-digest-options',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip, screen=OPTIONS_CHAIN'
            },
            domain: 'security'
        },
        'security-news': {
            menuId: 'security-news',
            menuLabel: ActionMenuLabels.NEWS,
            gotoPage: 'security-digest',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip'
            },
            domain: 'security'
        },
        /* 'trade-buy-equity' : {
            menuId: 'trade-buy',
            menuLabel: ActionMenuLabels.BUY,
            disabled: false,
            icon: 'fa-money',
            gotoPage: 'trading/new-order-entry/equity-order',
            payloadMetadata: {
                params: 'symId, , symbolRollOver={symId}, acctType, transactionType=BUY, PrepopTrdtype=Buy, rollOverIndicator=1'
            }
        },*/
        'trade-buy-more-equity': {
            menuId: 'trade-buy-more-equity',
            menuLabel: ActionMenuLabels.BUY,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType,transactionType=BUY, PrepopTrdtype=Buy, rollOverIndicator=1'
            },
            domain: 'account'
        },
        'holdings-buy-more-equity': {
            menuId: 'holdings-buy-more-equity',
            menuLabel: ActionMenuLabels.BUY_MORE,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType,transactionType=BUY, PrepopTrdtype=Buy, rollOverIndicator=1'
            },
            domain: 'account',
            disabled: true
        },
        /*
        'trade-sell-equity' : {
            menuId: 'trade-sell-equity',
            menuLabel: ActionMenuLabels.SELL,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType, transactionType, PrepopTrdtype,qty'
            },
            domain: 'account'
        },
        */
        'trade-sell-positions': {
            menuId: 'trade-sell-positions',
            menuLabel: ActionMenuLabels.SELL_FROM_POSITIONS,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, acctType, transactionType=SELL_FROM_PORTFOLIO, PrepopTrdtype=Sell, qty'
            },
            domain: 'account'
        },
        'trade-sell-covered': {
            menuId: 'trade-sell-covered',
            menuLabel: ActionMenuLabels.SELL_COVERED_CALLS,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType, accountType={acctType}, transactionType, transtype={transactionType}, qty'
            },
            domain: 'account'
        },
        'trade-sell-all-equity': {
            menuId: 'trade-sell-all-equity',
            menuLabel: ActionMenuLabels.SELL_ALL,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY || ORDER_BLASTING',
            payloadMetadata: {
                params: 'symId, acctType, transactionType=SELL_ALL, pcfnTransactionType=Sell, qty'
            },
            domain: 'account'
        },
        'trade-sell-short': {
            menuId: 'trade-sell-short',
            menuLabel: ActionMenuLabels.SELL_SHORT,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, acctType, transactionType=SELL_SHORT, pcfnTransactionType=Sell Short, qty'
            },
            domain: 'account'
        },
        'trade-buy-to-cover': {
            menuId: 'trade-buy-to-cover',
            menuLabel: ActionMenuLabels.BUY_TO_COVER,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, acctType, transactionType=BUY_TO_COVER, pcfnTransactionType=Buy to Cover, qty'
            },
            domain: 'account'
        },
        'trade-sell-covered-options': {
            menuId: 'trade-sell-covered-options',
            menuLabel: ActionMenuLabels.SELL_COVERED_CALLS,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType, accountType={acctType}, transactionType, transtype={transactionType}, qty'
            },
            domain: 'account',
            disabled: true
        },
        'trade-buy-mf': {
            menuId: 'trade-buy-mf',
            menuLabel: ActionMenuLabels.BUY,
            gotoPage: 'trading/new-order-entry/mutual-fund-order',
            role: 'MF_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, transactionType=BUY, selection=mfbuy1.trl, qty'
            },
            domain: 'account'
        },
        'trade-buy-mf-529plan': {
            menuId: 'trade-buy-mf-529plan',
            menuLabel: ActionMenuLabels.BUY,
            gotoPage: 'trading/new-order-entry/fund-529-order',
            role: 'PLAN_529_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbol={securityId}, symbolRollOver={symId}, transactionType=BUY, transaction=Buy, qty, securityId'
            },
            domain: 'account',
            disabled: true
        },
        'trade-redeem': {
            menuId: 'trade-redeem',
            menuLabel: ActionMenuLabels.REDEEM,
            gotoPage: 'mutual-fund-redeem',
            role: 'MF_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, transactionType=REDEEM, selection=mfdeem1.trl, qty'
            },
            domain: 'account'
        },
        'trade-redeem-mf-529plan': {
            menuId: 'trade-redeem-mf-529plan',
            menuLabel: ActionMenuLabels.REDEEM,
            gotoPage: 'trading/new-order-entry/fund-529-order',
            role: 'PLAN_529_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbol={securityId}, symbolRollOver={symId}, transactionType=REDEEM, transaction=Redeem, qty, securityId'
            },
            domain: 'account',
            disabled: true
        },
        'trade-exchange': {
            menuId: 'trade-exchange',
            menuLabel: ActionMenuLabels.EXCHANGE,
            gotoPage: 'mutual-fund-exchange',
            role: 'MF_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, transactionType=EXCHANGE, selection=mfexch1.trl, qty'
            },
            domain: 'account'
        },
        'trade-exchange-mf-529plan': {
            menuId: 'trade-exchange-mf-529plan',
            menuLabel: ActionMenuLabels.EXCHANGE,
            gotoPage: 'trading/new-order-entry/fund-529-order',
            role: 'PLAN_529_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbol={securityId}, symbolRollOver={symId}, transactionType=EXCHANGE, transaction=Exchange, qty, securityId'
            },
            domain: 'account',
            disabled: true
        },
        'trade-buy-calls-to-open': {
            menuId: 'trade-buy-calls-to-open',
            menuLabel: ActionMenuLabels.BUY_CALLS_TO_OPEN,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType, accounttype={acctType}, transactionType, transtype={transactionType}'
            },
            domain: 'account'
        },
        'trade-sell-calls-to-open': {
            menuId: 'trade-sell-calls-to-open',
            menuLabel: ActionMenuLabels.SELL_CALLS_TO_OPEN,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType, accounttype={acctType}, transactionType, transtype={transactionType}'
            },
            domain: 'account'
        },
        'trade-buy-puts-to-open': {
            menuId: 'trade-buy-puts-to-open',
            menuLabel: ActionMenuLabels.BUY_PUTS_TO_OPEN,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType, accounttype={acctType}, transactionType, transtype={transactionType}'
            },
            domain: 'account'
        },
        'trade-sell-puts-to-open': {
            menuId: 'trade-sell-puts-to-open',
            menuLabel: ActionMenuLabels.SELL_PUTS_TO_OPEN,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType, accounttype={acctType}, transactionType, transtype={transactionType}'
            },
            domain: 'account'
        },
        'trade-close-calls-puts': {
            menuId: 'trade-close-calls-puts',
            menuLabel: ActionMenuLabels.CLOSE_CALLS_PUTS,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType, accounttype={acctType}, transactionType, transtype={transactionType}'
            },
            domain: 'account'
        },
        'trade-away-fi': {
            menuId: 'trade-away-fi',
            menuLabel: ActionMenuLabels.TRADE_AWAY,
            gotoPage: 'trading.orderentry.ficenter',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver, acctType, transactionType, pcfnTransactionType, qty'
            },
            domain: 'account'
        },
        'trade-sell-fi': {
            menuId: 'trade-sell-fi',
            menuLabel: ActionMenuLabels.SELL,
            gotoPage: 'trading.orderentry.ficenter',
            role: 'FI_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, acctType, transactionType, pcfnTransactionType, qty'
            },
            domain: 'account'
        },
        'cfra-quickview': {
            menuId: 'cfra-quickview',
            menuLabel: ActionMenuLabels.CFRA_QUICK_VIEW,
            gotoPage: 'cfra-quick-view',
            role: 'CFRA_STK_RPT',
            payloadMetadata: {
                params: 'symId, symbol, cusip'
            },
            domain: 'security'
        },
        'account-note': {
            menuId: 'account-note',
            menuLabel: ActionMenuLabels.ADD_NOTE,
            gotoPage: 'account-note',
            role: 'VIEW_EDIT_NOTES',
            domain: 'account'
        },
        'calculate-loiroa': {
            menuId: 'calculate-loiroa',
            menuLabel: ActionMenuLabels.CALCULATE_LOI_ROA,
            gotoPage: 'calculate-loiroa',
            payloadMetadata: {
                params: 'symbol, cusip, omniIndicator, domaintype=account, publisherId=main-menu'
            },
            domain: 'account',
            disabled: true
        },
        'sell-positions': {
            menuId: 'sell-positions',
            menuLabel: ActionMenuLabels.SELL_POSITIONS,
            gotoPage: 'sell-positions',
            role: 'ORDER_BLASTING',
            payloadMetadata: {
                params: `strategy=buysell, assettype, transtype, symbol, cusip,` +
                `groupsrccd, groupcreatorid, groupid, groupname, accounts`
            },
            domain: 'group'
        },
        'periodic-instructions': {
            menuId: 'periodic-instructions',
            menuLabel: ActionMenuLabels.PERIODIC_INSTRUCTIONS,
            gotoPage: 'periodicinstructions-account',
            domain: 'account',
            disabled: true
        },
        'dividend-reinvestment': {
            menuId: 'dividend-reinvestment',
            menuLabel: ActionMenuLabels.DIVIDEND_REINVEST,
            gotoPage: 'dividend-reinvestment',
            payloadMetadata: {
                params: 'SecType={assetSubClass}, Cusip={cusip},page=dvre, account_id={accountNumber}'
            },
            domain: 'account',
            disabled: true
        },
        'calculate-cdsc': {
            menuId: 'calculate-cdsc',
            menuLabel: ActionMenuLabels.CALCULATE_CDSC,
            gotoPage: 'calculate-cdsc',
            domain: 'account',
            disabled: true
        },
    };

    public static NXP_ACTION_MENU_CONFIG = {
        emptylist: [],
        divider: ['divider'],
        account: ['holdings', 'balances', 'activity', 'pcf'],
        'account-closed': ['holdings', 'balances', 'activity', 'pcf'],
        'account-pending': ['holdings', 'balances', 'activity', 'pcf'],
        'account-managed': ['holdings', 'balances', 'activity', 'pcf'],
        'account-awaycustoday': ['holdings', 'balances'],
        household: ['holdings', 'balances', 'activity', 'pcf'],
        group: ['holdings', 'balances', 'activity', 'pcf'],
        client: ['holdings', 'balances', 'activity', 'pcf'],
        'security-equity': ['holdings-by-symbol', 'divider', 'quotes', 'option-quote', 'security-news', 'divider',
            'trade-buy-more-equity', 'holdings-buy-more-equity', 'trade-sell-positions', 'trade-sell-covered', 'trade-sell-covered-options', 'trade-sell-all-equity', 'trade-sell-short',
            'trade-buy-to-cover', 'divider', 'cfra-quickview', 'periodic-instructions', 'dividend-reinvestment' ],
        'security-mutfund': ['holdings-by-symbol', 'divider', 'calculate-loiroa', 'calculate-cdsc', 'quotes', 'cfra-quickview', 'security-news', 'divider',
            'trade-buy-mf', 'trade-buy-mf-529plan', 'trade-redeem', 'trade-redeem-mf-529plan', 'trade-exchange', 'trade-exchange-mf-529plan', 'periodic-instructions', 'dividend-reinvestment'],
        'security-option': ['holdings-by-symbol', 'divider', 'quotes', 'option-quote', 'security-news', 'divider',
            'trade-buy-calls-to-open', 'trade-sell-calls-to-open', 'trade-buy-puts-to-open',
            'trade-sell-puts-to-open', 'trade-close-calls-puts', 'periodic-instructions', 'dividend-reinvestment'],
        'security-fixedincome': ['holdings-by-symbol', 'divider', 'trade-sell-fi', 'trade-away-fi'],
        'security-common': ['holdings-by-symbol'],
        'security-group': ['quotes', 'option-quote', 'sell-positions'],
        'holdings-ibdoffip': ['holdings-by-symbol', 'holdings-iptotal']
    };

}
